export const cleanLineBreaksFromSignature = (signature: string) =>
  signature.replace(/[\r\n]/g, "");
